import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import MediaWithArtDirection from "./media-with-art-direction";
import { Carousel } from "react-responsive-carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { _ } from "../utils/i18n";

const CarouselImage = styled(MediaWithArtDirection)`
  height: 100%;
  width: 70%;
  position: relative;
`;
const CarouselWrapper = styled.div`
  position: relative;
  height: 100%;
  background: var(--color-white);
`;

const SlideButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  color: #333;
  height: 50px;
  width: 50px;
  font-size: 1rem;
  z-index: 99;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  opacity: 80%;

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    top: 45%;
    height: 40px;
    width: 40px;
  }

  &.prev {
    left: 1rem;
    svg {
      margin-right: 3px;
    }
  }
  &.next {
    right: 1rem;
    svg {
      margin-left: 3px;
    }
  }
`;

const SlideIndicator = styled.li`
  height: 4px;
  background: #dbdbdb;
  display: inline-block;
`;

const ImageIndex = styled.div`
  opacity: 0.6;
`;

export default function HeroCarousel({
  mediaItems,
  mediaItemsMobile,
  index,
  showPagination,
  onChangeIndex,
  showImageIndex,
  objectFit,
}) {
  return (
    <CarouselWrapper>
      <Carousel
        showStatus={false}
        infiniteLoop={true}
        showThumbs={false}
        selectedItem={index}
        onChange={(index) => onChangeIndex(index)}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <SlideButton
              onClick={onClickHandler}
              title={label}
              className="prev"
            >
              <FontAwesomeIcon icon={faChevronLeft} size="xl" />
            </SlideButton>
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <SlideButton
              onClick={onClickHandler}
              title={label}
              className="next"
            >
              <FontAwesomeIcon icon={faChevronRight} size="xl" />
            </SlideButton>
          )
        }
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (showPagination) {
            if (isSelected) {
              return (
                <SlideIndicator
                  style={{
                    background: "#343434",
                    width: `calc(100%/${mediaItems?.length})`,
                  }}
                  aria-label={`Selected: ${label} ${index + 1}`}
                  title={`Selected: ${label} ${index + 1}`}
                />
              );
            }
            return (
              <SlideIndicator
                style={{ width: `calc(100%/${mediaItems?.length})` }}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role="button"
                tabIndex={0}
                title={`${label} ${index + 1}`}
                aria-label={`${label} ${index + 1}`}
              />
            );
          }
          if (showImageIndex) {
            if (isSelected) {
              return (
                <ImageIndex>
                  {_(`Bilde ${index + 1} av ${mediaItems.length}`)}
                </ImageIndex>
              );
            }
          }
        }}
      >
        {mediaItems?.map((slide, index) => (
          <CarouselImage
            key={index}
            media={slide}
            mobileMedia={mediaItemsMobile?.[index]}
            loading="eager"
            objectFit={objectFit}
          />
        ))}
      </Carousel>
    </CarouselWrapper>
  );
}

HeroCarousel.propTypes = {
  mediaItems: PropTypes.arrayOf(PropTypes.object),
  mediaItemsMobile: PropTypes.arrayOf(PropTypes.object),
  index: PropTypes.number,
  showPagination: PropTypes.bool,
  onChangeIndex: PropTypes.func,
  showImageIndex: PropTypes.bool,
  objectFit: PropTypes.string,
};

HeroCarousel.defaultProps = {
  mediaItems: undefined,
  mediaItemsMobile: undefined,
  showPagination: true,
  showImageIndex: false,
};
